import type { FlatNamespace } from 'i18next'
import { useTranslation } from 'react-i18next'

export function useT<TNs extends FlatNamespace>(ns: TNs) {
  return useTranslation(ns)
}
